import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Tag, Typography } from 'antd';
import { useCallback, useContext, useEffect, useState } from 'react';
import { apiClient, hasGridsPageRole } from '../../utils';
import { UserContext } from '../contexts';
import { SearchPage } from '../search';
import { FloatingModal } from '../../elements';

export function Search() {
  const { Text } = Typography;

  const { user } = useContext(UserContext);

  const [searchModalOpen, setSearchModalOpen] = useState(false);

  const openSearchModal = () => {
    setSearchModalOpen(true);
  };

  const closeSearchModal = () => {
    setSearchModalOpen(false);
  };

  if (!hasGridsPageRole(user)) {
    return null;
  }

  return (
    <>
      <Button type="default" icon={<SearchOutlined />} onClick={openSearchModal} style={{ width: '100%', textAlign: 'left' }}>
        <Text type="secondary">| Arama</Text>
      </Button>
      <FloatingModal title="Arama" visible={searchModalOpen} footer={null} onCancel={closeSearchModal} destroyOnClose={true} width={'70%'}>
        <SearchPanel />
      </FloatingModal>
    </>
  );
}

export function SearchPanel(props: { initialSearchValue?: string }) {
  const { Search } = Input;
  const { Text } = Typography;

  const [phrase, setPhrase] = useState<string>();
  const [inputPhrase, setInputPhrase] = useState<string>();
  const [savedSearches, setSavedSearches] = useState<string[]>();

  useEffect(() => {
    if (props.initialSearchValue) {
      setInputPhrase(props.initialSearchValue);
      search(props.initialSearchValue);
    }
  }, [props.initialSearchValue]);

  const loadSavedSearches = useCallback(() => {
    apiClient
      .get('users/me/settings/searches')
      .then(response => {
        if (response.data) {
          setSavedSearches(response.data as string[]);
        } else {
          setSavedSearches(undefined);
        }
      })
      .catch(() => {});
  }, []);

  const deleteSavedSearch = (phrase: string) => {
    apiClient
      .delete('users/me/settings/searches', { data: { phrase } })
      .then(() => {
        loadSavedSearches();
      })
      .catch(() => {});
  };

  const onSavedSearchClose = (e: any, s: string) => {
    e.preventDefault();
    deleteSavedSearch(s);
  };

  const onSavedSearchClick = (s: string) => {
    setInputPhrase(s);
    search(s);
  };

  useEffect(() => {
    loadSavedSearches();
  }, [loadSavedSearches]);

  const search = (value: string) => {
    if (!value || value.length === 0) {
      setPhrase(undefined);
    } else if (value.length < 3) {
      return;
    }
    setPhrase(value);
  };

  return (
    <>
      <Search autoFocus size="large" onSearch={search} value={inputPhrase} onChange={e => setInputPhrase(e.target.value)} />
      <div style={{ marginTop: '1rem' }}>
        <Text type="secondary" style={{ fontSize: '0.8rem', marginRight: '0.5rem' }}>
          Kaydedilmiş aramalar:
        </Text>
        {savedSearches?.map(s => (
          <Tag
            key={s}
            closable
            style={{ cursor: 'pointer' }}
            color="purple"
            onClick={() => onSavedSearchClick(s)}
            onClose={e => onSavedSearchClose(e, s)}
          >
            {s}
          </Tag>
        ))}
      </div>
      {phrase && (
        <div style={{ marginTop: '1rem' }}>
          <SearchPage phrase={phrase} onSearchSaved={loadSavedSearches} />
        </div>
      )}
    </>
  );
}
